import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all certificados
export const getCertificados = () => {
  return authClient().get(`${API}/certificado?getDisabled=true`);
};

// Get certificado by id
export const getCertificadoById = (id) => {
  return authClient().get(`${API}/certificado/${id}`);
};

// Delete certificado
export const deleteCertificado = (id) => {
  return authClient().delete(`${API}/certificado/${id}`);
};

// Create certificado
export const postCertificado = async (certificado, selectedImage) => {
  if (selectedImage) {
    const response = await uploadSingleFile(selectedImage, "certificados");
    certificado.imageUrl = response?.data?.fileURL;
  }
  return authClient().post(`${API}/certificado`, certificado);
};

// Update certificado
export const updateCertificado = async (id, certificado, selectedImage) => {
  if (selectedImage) {
    const response = await uploadSingleFile(selectedImage, "certificados");
    certificado.imageUrl = response?.data?.fileURL;
  }
  return authClient().put(`${API}/certificado/${id}`, certificado);
};

// Change status certificado
export const changeStatusCertificado = async (id, active) => {
  return authClient().put(`${API}/certificado/change-status/${id}`, { active });
};

// Change order certificado
export const changeOrderCertificado = async (id, newOrder) => {
  return authClient().put(`${API}/certificado/change-order/${id}`, {
    newOrder,
  });
};
